<template>
  <div>
    <canvas id="planet-chart"></canvas>
  </div>
</template>

<script>
import Chart from 'chart.js'

export default {
  name: "PlanetChart",
  props: ['chartLabel', 'chartData','chartLineSlopData', 'labelLine1', 'labelLine2'],
  data: function () {
    return {
      planetChartData: {
        type: "line",
        data: {

          labels:this.chartLabel,

          datasets: [
            { // one line graph

              label: this.labelLine1,
              data: this.chartData,
              backgroundColor: [
                'rgba(146,106,255,0.31)', // Blue
              ],
              borderColor: [
                '#8057EF',
              ],
              fill: false,
              borderWidth: 3
            }, { // one line graph
              label: this.labelLine2,
              data: this.chartLineSlopData,
              backgroundColor: [
                'rgba(0,0,0,0.31)', // Blue
              ],
              borderColor: [
                '#060318',
              ],
              fill: false,
              borderWidth: 3
            },
          ],
          fill: false,
        },
        options: {
          legend: {
            display: true,
            position: 'top',
            rtl: true
          },


        }
      }
    }
  },
  mounted() {
    Chart.defaults.global.defaultFontFamily = "IRANSans";
    const ctx = document.getElementById('planet-chart');
    new Chart(ctx, this.planetChartData);
  }
}
</script>

<style scoped>

</style>